















import Vue from 'vue';
import MapView from "./components/Map.vue";
import PositionError from "./components/PositionError.vue";

export default Vue.extend({
	name: 'app',

	components: {
		MapView,
		PositionError,
	},

	data() {
		return {

			currentRace: undefined as any,

			races: [
				{
					id: "hammarby-sjo",
					title: "Hammarby Sjö",
					subTitle: "12 - 21 februari 2021",
					mapboxId: "ckjuhenuw026h2amiahztqf2p",
				},
				{
					id: "sodra-djurgarden-1",
					title: "Södra Djurgården",
					subTitle: "26 februari - 7 mars 2021",
					mapboxId: "ckjv9dn2t00cs28mkol1ljdeg",
				},
				{
					id: "brunnsviken",
					title: "Brunnsviken",
					subTitle: "12 - 21 mars 2021",
					mapboxId: "ckjv9sgyt05sr27ohrlshfdxd",
				},
				{
					id: "arstaviken",
					title: "Årstaviken",
					subTitle: "23 april - 2 maj 2021",
					mapboxId: "ckmth9c7a6eey20pabh7qciji",
				},
				{
					id: "magelungen",
					title: "Magelungen",
					subTitle: "7-9 & 15-17 oktober 2021",
					mapboxId: "cknd5dm513a5r22psqncnn4k7",
				},
				{
					id: "norra-djurgarden",
					title: "Norra Djurgården",
					subTitle: "21 - 30 maj 2021",
					mapboxId: "cko765ijw0ukv21jw5xud203x",
				},
				{
					id: "nackareservatet",
					title: "Nackareservatet",
					subTitle: "4 - 13 juni 2021",
					mapboxId: "ckp41h83k03tr21mg18fm7kji",
				},
				{
					id: "nackareservatet2",
					title: "Nackareservatet",
					subTitle: "27 augusti - 1 september 2021",
					mapboxId: "cks764j1u3zyp20jxzrfofmvr",
				},
				{
					id: "norra-djurgarden2",
					title: "Norra Djurgården",
					subTitle: "23-25/9 & 1-3/10 2021",
					mapboxId: "cktn4oiw20stw2enu503aeuzf",
				},
				{
					id: "ralambshov",
					title: "Rålambshov",
					subTitle: "21-23 & 29-31 oktober 2021",
					mapboxId: "ckusqbefb0y3j27ldw3j7olqd",
				},
				{
					id: "sodra-djurgarden",
					title: "Södra Djurgården",
					subTitle: "24 mars - 2 april 2023",
					mapboxId: "ckjv9dn2t00cs28mkol1ljdeg",
				},
				/*2022*/
				{
					id: "flaten",
					title: "Flaten",
					subTitle: "15 - 24 april 2022",
					mapboxId: "ckt05sikc2v4c20qjszj3ibpx",
				},
				{
					id: "vinterviken",
					title: "Vinterviken",
					subTitle: "20 - 29 maj 2022",
					mapboxId: "ckl96e1hn23oj28mrdx6jedtj",
				},
				{
					id: "karlberg",
					title: "Karlbergskanalen",
					subTitle: "14 - 23 april 2023",
					mapboxId: "ckyagfprz4jb327pdf758jhet",
				},
				{
					id: "grimsta",
					title: "Grimsta",
					subTitle: "25 mars - 3 april 2022",
					mapboxId: "cl05kx57m0sz027ms7mcxobwx",
				},
				{
					id: "sodra-djurgarden-10k",
					title: "Södra Djurgården 10K",
					subTitle: "6 - 15 maj 2022",
					mapboxId: "cl2gd61ui0gin21tjhy93owqc",
				},
				{
					id: "sodra-magelungen",
					title: "Södra Magelungen",
					subTitle: "3 - 12 juni 2022",
					mapboxId: "cl3sleatc1mv228lm38pd3ip1",
				},
				/*2023*/
				{
					id: "sodermalm",
					title: "Södermalm",
					subTitle: "10 - 19 mars 2023",
					mapboxId: "clb287ctg07jy21nuo8im8pts",
				},
				{
					id: "sodra-djurgarden-vt23",
					title: "Södra Djurgården",
					subTitle: "24 mars - 2 april 2023",
					mapboxId: "clctcxppx0pvd20p2k2x31wbu",
				},
				{
					id: "ulriksdal",
					title: "Ulriksdal",
					subTitle: "28 april - 7 maj 2023",
					mapboxId: "clbuxpsqh23jc28p6u18z23bw",
				},
				{
					id: "altasjon-vt23",
					title: "Ältasjön",
					subTitle: "12 - 21 maj 2023",
					mapboxId: "clctd7lff0nmg29lb4f1p2fga",
				},
				{
					id: "nackareservatet-vt23",
					title: "Nackareservatet",
					subTitle: "26 maj - 4 juni 2023",
					mapboxId: "clctckjkb05s620jx3vjgbkkt",
				},
				//2024
				{
					id: "norra-djurgarden-vt-24",
					title: "Norra Djurgården",
					subTitle: "17 - 26 maj 2024",
					mapboxId: "clrf34fkm0rtn1nmu9ar344ku",
				},
				{
					id: "hellas-vt-24",
					title: "Hellasgården",
					subTitle: "31 maj - 9 juni 2024",
					mapboxId: "clrf3i2co0v5l1nn4bei8oixt",
				},
				{
					id: "malarhojden-vt-24",
					title: "Mälarhöjden",
					subTitle: "19 - 28 april 2024",
					mapboxId: "clrf3ss140xxj1vp5xksm73aa",
				},
				{
					id: "djurgardskanalen-vt-24",
					title: "Djurgårdskanalen",
					subTitle: "5 - 14 april 2024",
					mapboxId: "clrf3wg4u0s2s20mubtmombxg",
				},
				{
					id: "sodermalm-vt-24",
					title: "Södermalm",
					subTitle: "3 - 12 maj 2024",
					mapboxId: "clb287ctg07jy21nuo8im8pts",
				},




				{
					id: "demo",
					title: "Demo",
					subTitle: "12 - 21 februari 2021",
					mapboxId: "ckjq53ryj0lhb2bmrzrh4gi43",
					visible: false,
				},

			],

			showPositionError: false,
		}
	},

	computed: {

		fill(): boolean {
			return location.search.indexOf("dev") != 1;
		},

		mapboxId(): string {
			return this.currentRace?.mapboxId;
		}
	},

	methods: {
		setCurrentRace() {
			const id = location.pathname.substring(1);
			this.currentRace = this.races.find(race => race.id == id);
		},

		// prevent zooming with wheel since ctrl-scroll zooms the map,
		// and it's annoying to zoom when you accidenatly hover another element
		wheelHandler(evt) {
			if (evt.ctrlKey) {
				evt.preventDefault();
			}
		},

		onPositionError() {
			this.showPositionError = true;
		}
	},

	mounted() {
		this.setCurrentRace();
	}


});
